<div
  *ngIf="
    ipBoardPart.signOptionSelected &&
    ipBoardPart.sign == null &&
    selectedSignOptionId !== RECOMMENDED_COLLABORATIVE_SIGN_OPTION_ID
  "
>
  <div class="ip-board-form-title">
    <div class="form-title-text">
      Kies type en afmetingen: hoogte x breedte
    </div>
  </div>
  <div
    class="form-section-padding measurements-and-type-selector selector-background-color"
  >
    <div>
      <mat-radio-group
        [value]="ipBoardPart.otherIPBoardPartType"
        (change)="setOtherIPBoardPartType($event.value)"
      >
        <mat-radio-button
          [value]="IP_BOARD_PART_TYPE_CHOICES.IP_70_100"
          [checked]="
            ipBoardPart.otherIPBoardPartType?.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.IP_70_100.ordinal
          "
          >IP 70 x 100 cm</mat-radio-button
        >
        <mat-radio-button
          *ngIf="
            selectedSignOptionId !== ALTERNATIVE_COLLABORATIVE_SIGN_OPTION_ID
          "
          [value]="IP_BOARD_PART_TYPE_CHOICES.IP_100_140"
          [checked]="
            ipBoardPart.otherIPBoardPartType?.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.IP_100_140.ordinal
          "
          >IP 100 x 140 cm (meest gekozen)</mat-radio-button
        >
        <mat-radio-button
          *ngIf="!isLeftRight"
          [value]="IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD"
          [checked]="
            ipBoardPart.otherIPBoardPartType?.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
          "
          >Kleefbord</mat-radio-button
        >
        <mat-radio-button
          [value]="IP_BOARD_PART_TYPE_CHOICES.OTHER_DIMENSIONS"
          [checked]="
            ipBoardPart.otherIPBoardPartType?.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.OTHER_DIMENSIONS.ordinal
          "
          >Andere afmetingen</mat-radio-button
        >
      </mat-radio-group>
    </div>
    <div>
      <ng-container
        *ngIf="
          ipBoardPart.otherIPBoardPartType?.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.IP_70_100.ordinal ||
          ipBoardPart.otherIPBoardPartType?.ordinal ===
            IP_BOARD_PART_TYPE_CHOICES.IP_100_140.ordinal
        "
      >
        <mat-radio-group
          [value]="customSelectedRightOption"
          (change)="setCustomSelectedRightOption($event.value)"
        >
          <mat-radio-button
            *ngFor="let option of CUSTOM_SIGN_IP_DIMENSION_OPTIONS_ARRAY"
            [value]="option"
            [checked]="customSelectedRightOption === option"
            >{{ option.label }}</mat-radio-button
          >
        </mat-radio-group>
      </ng-container>
      <ng-container
        *ngIf="
          ipBoardPart.otherIPBoardPartType?.ordinal ===
          IP_BOARD_PART_TYPE_CHOICES.OTHER_DIMENSIONS.ordinal
        "
      >
        <div class="flex-row field-input">
          <label>Hoogte</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="number"
              [(ngModel)]="ipBoardPart.otherHeight"
              (ngModelChange)="otherDimensionsChanged()"
            />
            <div matSuffix>cm</div>
          </mat-form-field>
        </div>
        <div class="flex-row field-input">
          <label>Breedte</label>
          <mat-form-field appearance="outline">
            <input
              matInput
              type="number"
              [(ngModel)]="ipBoardPart.otherWidth"
              (ngModelChange)="otherDimensionsChanged()"
            />
            <div matSuffix>cm</div>
          </mat-form-field>
        </div>
      </ng-container>
    </div>
    <div></div>
    <!-- reserved for board dimension previews but these were not included in PDF with images to use -->
  </div>
</div>
